import AppContainer from '../AppContainer';
import { useState, useEffect, useContext } from 'react';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCol,
  IonIcon,
  IonLabel,
  IonRow,
  IonProgressBar,
  IonGrid,
  IonItem,
  IonList,
  IonBreadcrumbs,
  IonBreadcrumb
} from '@ionic/react';
import { useLocation } from 'react-router-dom';
import { api } from '../domain/ApiService';
import { card, checkmark } from 'ionicons/icons';
import BillingButton from '../components/BillingButton';
import '../theme/plans.css';
import useAuth from '../domain/Auth';
import React from 'react';
import Menu from '../components/Menu';
import GlobalContext from '../domain/GlobalContext';

const Page: React.FC = () => {

  console.log('RENDER: Plan.tsx');
  const { user } = useContext(GlobalContext);
  const [usage, setUsage] = useState(0);
  const [cost, setCost] = useState(0.0);
  const location = useLocation();  

  const loadUsage = async () => {
 
    try {

      const response = await api("/user/usage", {}, undefined); 
      console.log(JSON.stringify(response));

      if (response != null && response.length > 0 && response[0].total_costs > 0) {

        const totalCosts = response[0].total_costs;
        setCost(parseFloat(totalCosts.toFixed(2)))
        const calculatedProgress = totalCosts / 10;
        setUsage(Math.min(calculatedProgress, 1));
      }
      else {

        setUsage(Math.min(0, 1));
      }

    } catch (err) {
      console.error('Error:', err);
    }
  };
  useEffect(() => {

    console.log(location.pathname)
    if (location.pathname === "/plan")
      loadUsage();

  }, [location]);

  return (

    <div>

            {/* 
            <IonCard className='filled' style={{ padding: "10px" }}>
              <IonCardHeader>
                <IonCardTitle>Usage</IonCardTitle>
                {(user && user.openai) ? 
                    (<p>Token consumption: ${cost}</p>) : 
                    (<p>Token consumption: ${cost} / {(user && user.stripe_id != null) ? "$10.00" : "$5.00"}</p>)
                }
              </IonCardHeader>
              <IonCardContent>
                <IonProgressBar value={(user && user.openai) ? 0 : usage}></IonProgressBar>
              </IonCardContent>
            </IonCard>
            */}

            <IonGrid style={{paddingLeft: '0px', marginLeft: '0px'}}>
                <IonRow style={{paddingLeft: '0px', marginLeft: '0px'}}>
                    <IonCol style={{paddingLeft: '0px', marginLeft: '0px'}} size-xs="12" size-sm="6" size-md="4" size-lg="4">
                    <IonCard className='filled plan'>
                        <IonCardHeader>
                          <IonCardTitle className="plan">
                            Free
                            <div className="plan-container">
                              <div className="plan-price-container">
                                <div className="plan-dollar">$</div>
                                <div className="plan-price">0</div>
                                <div className="plan-period">/ month</div>
                              </div>
                              <div className="plan-description">
                              For exploring and using.
                              </div>
                            </div>                           
                          </IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>       
                          <IonList className='transparent'>
                            <IonItem color="none" lines="none">
                              <IonIcon aria-hidden="true" icon={checkmark} slot="start"></IonIcon>
                              <IonLabel>Single user</IonLabel>
                            </IonItem>
                            <IonItem color="none" lines="none">
                              <IonIcon aria-hidden="true" icon={checkmark} slot="start"></IonIcon>
                              <IonLabel>Use all free launchpads</IonLabel>
                            </IonItem>
                            <IonItem color="none" lines="none">
                              <IonIcon aria-hidden="true" icon={checkmark} slot="start"></IonIcon>
                              <IonLabel>Buy premium launchpads</IonLabel>
                            </IonItem>
                          </IonList>
                        </IonCardContent>
                        <IonButton routerLink='/account' className="basic plan" disabled={true}>
                          Current  
                        </IonButton>
                      </IonCard>
                    </IonCol>
                    <IonCol style={{paddingLeft: '0px', marginLeft: '0px'}} size-xs="12" size-sm="6" size-md="4" size-lg="4">
                    <IonCard className='filled plan'>
                        <IonCardHeader>
                        <IonCardTitle className="plan">
                            <div style={{width: "100%"}}>
                            Creator
                            </div>
                            <div className="plan-container">
                              <div className="plan-price-container">
                                <div className="plan-dollar">$</div>
                                <div className="plan-price">35</div>
                                <div className="plan-period">/ month</div>
                              </div>
                              <div className="plan-description">
                              For building and selling.
                              </div>
                            </div>                           
                          </IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>      
                          <IonList className='transparent'>
                            <IonItem color="none" lines="none">
                              <IonIcon aria-hidden="true" icon={checkmark} slot="start"></IonIcon>
                              <IonLabel>All standard features</IonLabel>
                            </IonItem>
                            <IonItem color="none" lines="none">
                              <IonIcon aria-hidden="true" icon={checkmark} slot="start"></IonIcon>
                              <IonLabel>Individual creator</IonLabel>
                            </IonItem>
                            <IonItem color="none" lines="none">
                              <IonIcon aria-hidden="true" icon={checkmark} slot="start"></IonIcon>
                              <IonLabel>Build your launchpads</IonLabel>
                            </IonItem>
                            <IonItem color="none" lines="none">
                              <IonIcon aria-hidden="true" icon={checkmark} slot="start"></IonIcon>
                              <IonLabel>Sell in the launchpad store</IonLabel>
                            </IonItem>
                          </IonList>
                        </IonCardContent>
                        {/* <BillingButton /> */}
                        <IonButton className="basic plan" onClick={() => window.open('https://growhold.com/contact/company', '_blank')}>Contact us</IonButton>
                      </IonCard>
                    </IonCol>
                    <IonCol style={{paddingLeft: '0px', marginLeft: '0px'}} size-xs="12" size-sm="6" size-md="4" size-lg="4">
                    <IonCard className='filled plan'>
                        <IonCardHeader>
                          <IonCardTitle className="plan">
                            Business
                            <div className="plan-container">
                              <div className="plan-price-container">
                                <div className="plan-dollar">$</div>
                                <div className="plan-price">95</div>
                                <div className="plan-period">/ month</div>
                              </div>
                              <div className="plan-description">
                              For teams and scaling.
                              </div>
                            </div>                           
                          </IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>      
                          <IonList className='transparent'>
                            <IonItem color="none" lines="none">
                              <IonIcon aria-hidden="true" icon={checkmark} slot="start"></IonIcon>
                              <IonLabel>All creator features</IonLabel>
                            </IonItem>
                            <IonItem color="none" lines="none">
                              <IonIcon aria-hidden="true" icon={checkmark} slot="start"></IonIcon>
                              <IonLabel>Includes 3 users</IonLabel>
                            </IonItem>
                            <IonItem color="none" lines="none">
                              <IonIcon aria-hidden="true" icon={checkmark} slot="start"></IonIcon>
                              <IonLabel>$25/mo per extra user</IonLabel>
                            </IonItem>
                            <IonItem color="none" lines="none">
                              <IonIcon aria-hidden="true" icon={checkmark} slot="start"></IonIcon>
                              <IonLabel>Team launchpads</IonLabel>
                            </IonItem>
                          </IonList>
                        </IonCardContent>
                        <IonButton className="basic plan" onClick={() => window.open('https://growhold.com/contact/company', '_blank')}>Contact us</IonButton>
                      </IonCard>
                    </IonCol>
                    </IonRow>
              </IonGrid>

    </div>
  );
};

const Breadcrumb: React.FC = () => {
  return (
    <IonBreadcrumbs>
      <IonBreadcrumb>
        <IonIcon slot="start" icon={card}></IonIcon>
        Usage & billing
      </IonBreadcrumb>
    </IonBreadcrumbs>
  );
};

const MemoizedPage = React.memo(Page);
const MemoizedBreadcrumb = React.memo(Breadcrumb);

const Container: React.FC<{}> = () => { return <AppContainer ContentComponent={MemoizedPage} BreadcrumbComponent={MemoizedBreadcrumb} MenuComponent={Menu} />; };
export default Container;